import Preact from 'preact'
import { IClip } from '../../../../../types'
import * as styles from './index.css'
import distanceInWords from 'date-fns/distance_in_words_to_now'
import format from 'date-fns/format'
import locale from 'date-fns/locale/nb'
import { firebaseInstance } from '../../../../db/firebase'
import { waitUntil } from '../../../../../lib/wait-until'
import { ViewCounter } from '../ViewCounter'
import { LikeButton } from '../LikeButton'
import { bem } from '@nrk/dh-utils'
import { PlayIcon } from '../../../common/Icons/PlayIcon'

const { h, Component } = Preact

type Subscription = (...args: any[]) => void
interface IProps {
  clip: IClip
  showViews: boolean
  showLikes: boolean
}

interface IState {
  viewCount: number
  likeCount: number
  liked: boolean
}

class ClipsPreview extends Component<IProps, IState> {
  public viewSubscription: any

  public state = {
    viewCount: 0,
    likeCount: 0,
    liked: false
  }

  public componentDidMount() {
    this.updateCounts()
    this.updateLiked()
  }

  public updateLiked = async () => {
    if (!firebaseInstance) {
      await waitUntil(() => !!firebaseInstance, 1000).catch(console.error)
    }

    if (firebaseInstance) {
      const { id } = this.props.clip
      const liked = await firebaseInstance.getLikeState(id)

      this.setState({ liked })
    }
  }

  public updateCounts = async () => {
    if (!this.props.showViews) return

    if (!firebaseInstance) {
      await waitUntil(() => !!firebaseInstance, 1000).catch(console.error)
    }

    if (firebaseInstance) {
      const { id } = this.props.clip
      const [viewCount, likeCount] = await Promise.all([
        firebaseInstance.getViewCount(id),
        firebaseInstance.getLikeCount(id)
      ])

      this.setState({ viewCount, likeCount })
    }
  }

  public render() {
    const { showLikes, clip, showViews } = this.props
    const { viewCount, likeCount, liked } = this.state
    const { id, lastUpdated, duration, title } = clip
    const dateStr = distanceInWords(new Date(lastUpdated), { locale })
    const timeStr = format(new Date(duration), 'm:ss')

    return (
      <div>
        <div class={styles['preview-item__poster']}>
          <img src={clip.poster.thumbnail} />
          <div class={styles['preview-item__gradient']} />
          <div class={styles['preview-item__header']}>
            <h3 class={styles['preview-item__title']}>{title}</h3>
          </div>
          <div class={styles['preview-item__header-info']}>
            <span class={styles['preview-item__duration']}>{timeStr}</span>
          </div>
          <div class={styles['preview-item__play-btn']}>
            <PlayIcon class={styles['preview-item__play-icon']} />
          </div>
        </div>
        {(showLikes || showViews) && (
          <div class={styles['preview-item__info-box']}>
            {showViews && <ViewCounter clip={clip} />}
            {showLikes && <LikeButton clip={clip} notClickable={true} />}
          </div>
        )}
      </div>
    )
  }
}

export { ClipsPreview }
